export default "__VITE_ASSET__BLt8UBS2__"